import { DetailedGameRound } from '@/models/detailed-round';
import { Tile } from '@/models/tiles';

export function getCardIndex(
  round: DetailedGameRound,
  tiles: Tile[],
  originalTiles: Tile[],
) {
  if (!round || !tiles || !originalTiles) {
    return 0;
  }

  return (
    originalTiles.length * 6 +
    tiles.findIndex(
      item => item?.id?.toString() === round?.roulette?.tileId?.toString(),
    )
  );
}
